module.exports = __webpack_public_path__ + "img/service_web_solutions_5_mob_2x.edb281c3.jpg";